import { getProductData } from '@elem/utils/getProductData';
import { useEffect } from 'react';
import { useProductDispatch, useProductStore } from '../../ProductProvider';
import getLocal from '@/app/utils/getLocal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';

const generalKey = 'product_sp_125W_Bifacial_Modular_Solar_Panel';

export default function GetProductData() {
    const { gloproductlist } = useGlobal();
    const { productPageData } = useProductStore();
    const dispatch = useProductDispatch();
    const { locale } = getLocal();
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    console.log(productMsg, 'productMsg====');
    useEffect(() => {
        const getProductDataHandle = async () => {
            const productPageData = await getProductData(productMsg, locale, productMsg?.spuId || productMsg?.sourceId);
            dispatch({
                type: 'changeProductPageData',
                payload: productPageData,
            });
        };
        const productCatagory = productPageData?.productCatagory;
        if (!productCatagory) {
            getProductDataHandle();
        }
    }, []);
    return null;
}
